import APP_CONFIG from '../app.config';
import {DEFAULT_LANGUAGE, getLanguage} from './language.utils';
import fmsMod from '../../common/flashmessageservice/flashmessageservice.module';

class TranslationService {
  constructor($q, $log, $http, gettextCatalog) {
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
    this.gettextCatalog = gettextCatalog;

    /**
     * Currently active language
     * @type {string}
     */
    this.lang = getLanguage();

    // Create promise that will be listened to by bundles unless one already exists
    if (window._translationservice_loading == null) {
      window._translationservice_loading = this.$q((resolve, reject) => {
        window._translationservice_loading_resolve = resolve;
        window._translationservice_loading_reject = reject;
      });
    }
  }

  /**
   * Load translations for the currently active language.
   *
   * If the currently active language is the default language, nothing is done.
   */
  loadTranslations() {
    if (this.lang === DEFAULT_LANGUAGE) {
      // Translations for the default language are built in to the code, so nothing needs to be done
      window._translationservice_loading_resolve();
      return this.$q.when();
    }

    // The following line works around a bug in Webpack where it doesn't find APP_CONFIG inside the interpolation
    const conf = APP_CONFIG;
    const url = `${conf.translation_path}/translations_${this.lang}.json?v=${conf.version}`;

    return this.$http.get(url).then(response => {
      this.$log.debug(`Acquired ${Object.keys(response.data[this.lang]).length} translations for language ${this.lang}.`);
      window._translationservice_data = response.data[this.lang];
    });
  }

  /**
   * Return a promise that resolves when translations have been loaded and configured.
   * @return {Promise}
   */
  waitForTranslations() {
    return window._translationservice_loading.then(() => {
      this.gettextCatalog.setCurrentLanguage(this.lang);
      this.gettextCatalog.setStrings(this.lang, window._translationservice_data);
    });
  }
}

const mod = angular.module('app.common.translationService', [])

.service('TranslationService', TranslationService);

/**
 * Initialise and configure translations by loading the appropriate translation file.
 */
function initTranslations($log, TranslationService, FlashMessageService) {
  'ngInject';

  return TranslationService.loadTranslations()
  .then(() => {
    window._translationservice_loading_resolve();
  })
  .then(() => TranslationService.waitForTranslations())
  .catch(err => {
    FlashMessageService.addMessage(
      'Unable to load translations. Page will be loaded in Finnish.',
      ['error']
    );
    $log.error('Unable to load translations, error data:', err);
    window._translationservice_loading_resolve();
  });
}
initTranslations.imports = [mod.name, fmsMod];

export {initTranslations};
export default mod.name;
